import styled from 'styled-components';
import { DealerCommentStyled } from '../DealerCommentStyled';

export const DealerCommentStyledAP = styled(DealerCommentStyled)``;
